import React, { useContext, useEffect, useState } from 'react'
import { CandidatesContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidateEntrance, saveCandidateEntrance } from '../../../actions/candidates'
import { getApplicantNameExams } from '../../../actions/applicantGroup'
import styles from './styles.module.scss'
import admStyles from './Admission.module.scss'
import Button from '../../../components/Button'
import { Checkbox, Input, Select } from '../../../components/ModalInputs'
import Table from '../../../components/Table'
import { useFormik } from 'formik'
import { schoolGrades } from '../../../assets/const'

const DEFAULT_GPA_ROWS = Array.from({ length: 6 }, (_, i) => ({ id: i + 1, name: '', score: '' }))

const ANTHROPOMETRY = [
  { id: 1, parameter: 'Размер головного убора', value: '' },
  { id: 2, parameter: 'Обхват шеи (см)', value: '' },
  { id: 3, parameter: 'Длина брюк (см)', value: '' },
  { id: 4, parameter: 'Длина рукава (см)', value: '' },
  { id: 5, parameter: 'Длина плеча (см)', value: '' },
  { id: 6, parameter: 'Длина стопы (см)', value: '' },
  { id: 7, parameter: 'Длина юбки (см)', value: '' },
  { id: 8, parameter: 'Обхват груди (см)', value: '' },
  { id: 9, parameter: 'Обхват талии (см)', value: '' },
  { id: 10, parameter: 'Обхват бёдер (см)', value: '' },
  { id: 11, parameter: 'Рост (см)', value: '' },
  { id: 12, parameter: 'Вес (кг)', value: '' },
]

export default function Admission() {
  const { candidateId, closeModal } = useContext(CandidatesContext)
  const dispatch = useDispatch()
  const { entrance: data } = useSelector(state => state.candidates.data)
  const { name_exams } = useSelector(state => state.applicant_group)

  const [gpaRows, setGpaRows] = useState(DEFAULT_GPA_ROWS)
  const [anthropometry, setAnthropometry] = useState(ANTHROPOMETRY)

  useEffect(() => {
    if (candidateId !== 'add') dispatch(getCandidateEntrance(candidateId))
    dispatch(getApplicantNameExams())
  }, [])

  useEffect(() => {
    if (!data) return
    if (Array.isArray(data.gpa_rows) && data.gpa_rows.length) {
      setGpaRows(data.gpa_rows)
    }
    if (Array.isArray(data.calc_antro) && data.calc_antro.length) {
      setAnthropometry(data.calc_antro)
    }
  }, [data])

  const { values, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    onSubmit: (formData) => {
      dispatch(saveCandidateEntrance(candidateId, {
        ...formData,
        gpa_rows: gpaRows,
        calc_antro: anthropometry,
      }))
    },
  })

  const v = (name) => values[name] ?? ''

  const updateGpa = (id, field, value) => {
    setGpaRows(prev => prev.map(r => r.id === id ? { ...r, [field]: value } : r))
  }

  const updateAntro = (id, value) => {
    setAnthropometry(prev => prev.map(r => r.id === id ? { ...r, value } : r))
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>

          {/* Заголовок */}
          <div className={admStyles.topRow}>
            <h3 className={admStyles.admTitle}>ДОПУЩЕН К ВСТУПИТЕЛЬНЫМ ИСПЫТАНИЯМ</h3>
            {!v('exam_group') && (
              <span className={admStyles.groupWarning}>Не указана экзаменационная группа!</span>
            )}
            <Checkbox
              label='Не явился'
              name='absent'
              checked={!!v('absent')}
              onChange={e => setFieldValue('absent', e.target.checked ? 1 : 0)}
            />
          </div>

          {/* Причина отказа + Нагрудный номер */}
          <div className={admStyles.causeRow}>
            <Input
              label='Причина отказа'
              name='causefailure'
              value={v('causefailure')}
              onChange={handleChange}
              style={{ flex: 1 }}
            />
            <Input
              label='Нагрудный номер для ОФП'
              name='ofpnumber'
              value={v('ofpnumber')}
              onChange={handleChange}
              style={{ width: '160px' }}
            />
          </div>

          {/* ГПА + Балл | Психологическое тестирование */}
          <div className={admStyles.mainCols}>
            <div className={admStyles.gpaBlock}>
              <div className={admStyles.gpaHeader}>
                <span>ГПА</span>
                <span>Балл</span>
              </div>
              {gpaRows.map(row => (
                <div key={row.id} className={admStyles.gpaRow}>
                  <select
                    value={row.name}
                    onChange={e => updateGpa(row.id, 'name', e.target.value)}
                    className={admStyles.gpaSelect}
                  >
                    <option value=''></option>
                    {name_exams?.map(e => (
                      <option key={e.xp_key ?? e.id ?? e.name} value={e.name}>{e.name}</option>
                    ))}
                  </select>
                  <input
                    type='number'
                    value={row.score}
                    onChange={e => updateGpa(row.id, 'score', e.target.value)}
                    className={admStyles.gpaScore}
                  />
                </div>
              ))}
            </div>

            <div className={admStyles.psychBlock}>
              <div className={admStyles.psychTitle}>Психологическое тестирование</div>
              <div className={admStyles.psychRow}>
                <span className={admStyles.psychLabel}>Словарный запас</span>
                <input
                  type='number'
                  step='0.01'
                  value={v('psych_vocab')}
                  onChange={e => setFieldValue('psych_vocab', e.target.value)}
                  className={admStyles.psychScore}
                />
                <span className={admStyles.dopusk}>допуск</span>
              </div>
            </div>
          </div>

          {/* Коэффициент + Итоговое заключение */}
          <div className={admStyles.coeffRow}>
            <Input
              label='Коэффициент'
              name='coeff'
              value={v('coeff')}
              onChange={handleChange}
              style={{ width: '100px' }}
            />
            <Input
              label='Итоговое заключение'
              name='final_conclusion'
              value={v('final_conclusion')}
              onChange={handleChange}
              style={{ width: '100px' }}
            />
          </div>

          {/* Статистика */}
          <div className={admStyles.statsBlock}>
            <div className={admStyles.statsLines}>
              <div>
                Средний балл за экзамены:{' '}
                <b>{v('avg_exam') || '0,00'}</b>
                {', '}включая псих. тесты:{' '}
                <b>{v('avg_exam_psych') || '0,00'}</b>
              </div>
              <div>
                Суммарный балл за экзамены:{' '}
                <b>{v('sum_exam') || '0,00'}</b>
                {', '}включая псих. тесты:{' '}
                <b>{v('sum_exam_psych') || '0,00'}</b>
              </div>
            </div>
            <div className={admStyles.singleScore}>
              ЕДИНАЯ БАЛЛЬНАЯ ОЦЕНКА: {v('single_grade') || '0,00'}
            </div>
          </div>

          {/* Повышающие показатели */}
          <h5>Повышающие показатели</h5>
          <div className={admStyles.boostRow}>
            <Input
              label='Средний балл по табелю'
              name='tabel_avg'
              value={v('tabel_avg')}
              onChange={handleChange}
              style={{ width: '100px' }}
            />
            <Input
              label='Участие в олимпиадах, конкурсах'
              name='olympic_grade'
              value={v('olympic_grade')}
              onChange={handleChange}
              style={{ width: '100px' }}
            />
            <Select
              label='Балл за портфолио'
              name='portfoliograde'
              value={v('portfoliograde')}
              onChange={handleChange}
              style={{ width: '80px' }}
            >
              <option value=''>—</option>
              {schoolGrades.map(g => <option key={g.value} value={g.value}>{g.name}</option>)}
            </Select>
            <Select
              label='Техническая и специальная физическая подготовленность'
              name='techno'
              value={v('techno')}
              onChange={handleChange}
              style={{ width: '80px' }}
            >
              <option value=''>—</option>
              {schoolGrades.map(g => <option key={g.value} value={g.value}>{g.name}</option>)}
            </Select>
          </div>

          {/* Антропометрические данные */}
          <h5>Антропометрические данные</h5>
          <Table style={{ width: '55%', maxHeight: '220px', overflowY: 'auto', display: 'block' }}>
            <thead>
              <tr>
                <th>Параметр</th>
                <th>Значение</th>
              </tr>
            </thead>
            <tbody>
              {anthropometry.map(row => (
                <tr key={row.id}>
                  <td>{row.parameter}</td>
                  <td>
                    <Input
                      style={{ width: '100px', margin: 0 }}
                      value={row.value}
                      onChange={e => updateAntro(row.id, e.target.value)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

        </div>
      </div>
      <div className={styles.modalFooter}>
        <div>
          <div>Создал: </div>
          <div>Изменил: </div>
        </div>
        <Button mode='white' onClick={handleSubmit}>Сохранить</Button>
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </>
  )
}
